import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Header.scss';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        // Dışarı tıklandığında menüyü kapatma işlevi
        const handleClickOutside = (event) => {
            const navMenu = document.querySelector('.nav-menu');
            const mobileButton = document.querySelector('.mobile-menu-button');
            
            if (isMobileMenuOpen && navMenu && !navMenu.contains(event.target) && !mobileButton.contains(event.target)) {
                setIsMobileMenuOpen(false);
            }
        };
        
        // Sayfa geçişlerinde menüyü otomatik kapatma
        const handleNavigation = () => {
            setIsMobileMenuOpen(false);
        };
        
        // Etkinlikleri ekle
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        
        // Temizleme fonksiyonu
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isMobileMenuOpen]);
    
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }

            const dynamicText = document.getElementById('dynamic-header-text');

            // Check if we are on the team application page
            const isTeamApplicationPage = window.location.pathname.includes('/takimbasvuru') ||
                window.location.pathname.includes('/toplulukbasvuru');

            if (dynamicText) {
                // If on team application page, set fixed text
                if (isTeamApplicationPage) {
                    dynamicText.textContent = 'ARAMIZA KATIL';
                    return;
                }

                // Otherwise update based on section in view
                const heroSection = document.querySelector('.hero-section');
                const timelineSection = document.getElementById('timeline');
                const joinSection = document.getElementById('combined-sections');
                const teamSection = document.getElementById('team');
                const neredeSection = document.getElementById('nerede');
                const combinedSections = document.querySelector('.combined-sections');
                // how to select combined-sections on where classname = combined-sections
                // const combinedSections = document.querySelector('.combined-sections');

                // Yeni sıralı konfigürasyon
                const sectionConfig = [
                    {
                        id: 'hero',
                        element: heroSection,
                        text: 'HOŞGELDİNİZ',
                        order: 1
                    },
                    {
                        id: 'nerede',
                        element: neredeSection,
                        text: 'SUNUCULARIMIZ',
                        order: 2
                    },
                    {
                        id: 'combinedSections',
                        element:  combinedSections,
                        text: 'NASIL OLUNUR',
                        order: 3
                    },
                    {
                        id: 'timeline',
                        element: timelineSection ,
                        text: 'BAŞARILARIMIZ',
                        order: 4
                    },
                    {
                        id: 'team',
                        element: teamSection,
                        text: 'ÜYELERİMİZ',
                        order: 5
                    }
                ];

                // Default text eğer hiçbir section görünür değilse
                const defaultText = '';
                const scrollPos = window.scrollY + 200; // Offset for better trigger

                // Section'ların görünürlük durumlarını hesapla
                const visibleSections = sectionConfig
                    .filter(section => {
                        if (!section.element) return false;
                        
                        const sectionOffset = section.offset || 0;
                        const sectionTop = section.element.offsetTop + sectionOffset;
                        const sectionBottom = sectionTop + section.element.offsetHeight;
                        
                        return scrollPos >= sectionTop && scrollPos < sectionBottom;
                    })
                    .sort((a, b) => a.order - b.order);
                
                // En düşük order değerine sahip görünür section'u seç
                const activeSection = visibleSections.length > 0 ? visibleSections[0] : null;

                // Eğer aktif bir section varsa onun text'ini, yoksa default text'i kullan
                dynamicText.textContent = activeSection ? activeSection.text : defaultText;
            }
        };

        window.addEventListener('scroll', handleScroll);
        // Initial call to set correct text without scrolling
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
            <div className="header-container">
                <Link to="/" className="logo-container">
                    <img
                        src="/assets/images/owl-logo.png"
                        alt="Black owLs Logo"
                        className="logo-image"
                    />
                    <span className="logo-text">Black owLs <span className="gold-text" id="dynamic-header-text"></span></span>
                </Link>

                <div className="navigation-container">
                    <button
                        className="mobile-menu-button"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <nav className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                        <button className="close-menu-button" onClick={() => setIsMobileMenuOpen(false)}>
                            <span>&times;</span>
                        </button>
                        <ul>
                            <li><Link to="/" onClick={() => setIsMobileMenuOpen(false)}>ANA SAYFA</Link></li>
                            <li>
                                <a 
                                    href="/kurallar" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    KURALLAR
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://stats.squadtr.com/owl/match/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    STATS
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://strat.squadtr.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    TAKTİK
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="https://squadmaps.com/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    MAPS
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="https://squadcalc.app/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    MORTAR
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="https://discord.blackowls.net/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="discord-link"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    DISCORD
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="/takimbasvuru" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="join-button"
                                    onClick={() => setIsMobileMenuOpen(false)}
                                >
                                    ARAMIZA KATIL
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;